import React from "react";

const ChatHeaderSkeleton = () => {
  return (
    <div>
      <div
        className="skeleton-loading"
        style={{
          width: "200px",
          height: "23px",
          borderRadius: "var(--border-radius-sm)",
        }}
      ></div>
      <div
        className="skeleton-loading"
        style={{
          width: "170px",
          height: "19px",
          marginTop: "4.6px",
          borderRadius: "var(--border-radius-sm)",
          marginInline: "auto",
        }}
      ></div>
    </div>
  );
};

export default ChatHeaderSkeleton;
